export const SOFTLINE_API_TIMESTAMP = '/v1/timestamp/entities';
export const SOFTLINE_API_TIMESTAMP_TEMPLATE = '/v1/timestamp/default';
export const SOFTLINE_API_TIMESTAMP_VALIDATION = '/v1/timestamp/validate';
export const SOFTLINE_API_TIMESTAMP_CODE = '/v1/timestamp/code/entities';
export const SOFTLINE_API_EMPLOYEES = '/v1/employees/entities';
